// ----------------------------------------------------------------------------
// Snippet: Tooltip
// ----------------------------------------------------------------------------
//
// Some JS to handle touch devices
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_toggletip.scss';

// Variables
import 'snippets/toggletip/accessible-tooltip';
